"use strict";
/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
Object.defineProperty(exports, "__esModule", { value: true });
exports.NetUploadIcon = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var forwardRef_1 = require("../../helpers/forwardRef");
var Icon_1 = require("../../internal/Icon");
var NetUploadIcon16Light_1 = require("./NetUploadIcon16Light");
var NetUploadIcon16Regular_1 = require("./NetUploadIcon16Regular");
var NetUploadIcon16Solid_1 = require("./NetUploadIcon16Solid");
var NetUploadIcon20Light_1 = require("./NetUploadIcon20Light");
var NetUploadIcon20Regular_1 = require("./NetUploadIcon20Regular");
var NetUploadIcon20Solid_1 = require("./NetUploadIcon20Solid");
var NetUploadIcon24Regular_1 = require("./NetUploadIcon24Regular");
var NetUploadIcon24Solid_1 = require("./NetUploadIcon24Solid");
var NetUploadIcon32Regular_1 = require("./NetUploadIcon32Regular");
var NetUploadIcon64Regular_1 = require("./NetUploadIcon64Regular");
var sizes = {
    16: {
        light: NetUploadIcon16Light_1.NetUploadIcon16Light,
        regular: NetUploadIcon16Regular_1.NetUploadIcon16Regular,
        solid: NetUploadIcon16Solid_1.NetUploadIcon16Solid,
    },
    20: {
        light: NetUploadIcon20Light_1.NetUploadIcon20Light,
        regular: NetUploadIcon20Regular_1.NetUploadIcon20Regular,
        solid: NetUploadIcon20Solid_1.NetUploadIcon20Solid,
    },
    24: {
        regular: NetUploadIcon24Regular_1.NetUploadIcon24Regular,
        solid: NetUploadIcon24Solid_1.NetUploadIcon24Solid,
    },
    32: {
        regular: NetUploadIcon32Regular_1.NetUploadIcon32Regular,
    },
    64: {
        regular: NetUploadIcon64Regular_1.NetUploadIcon64Regular,
    },
};
exports.NetUploadIcon = forwardRef_1.forwardRef('NetUploadIcon', function (props, ref) {
    return react_1.default.createElement(Icon_1.Icon, tslib_1.__assign({ ref: ref }, props, { sizes: sizes }));
});
